export class ListResult<T> {
  records: number;
  orderBy: string;
  data: Array<T> = [];
}
